import { render, staticRenderFns } from "./ProviderPage.vue?vue&type=template&id=2bd74b1b"
import script from "./ProviderPage.vue?vue&type=script&lang=js"
export * from "./ProviderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports